import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseUnpaidAmountFormalNoticeTemplates = [
  {
    id: '-126001',
    language: Language.EN,
    subject: 'Formal notice for unpaid amount',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_UNPAID_AMOUNT_FORMAL_NOTICE,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerns: formal notice with regard to an unpaid amount related to the lease located at <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        {{#if isPartiallyPaid}}
        <p>Unless we are mistaken, we have still not received full payment of {{getInvoiceOrPaymentRequest lease}} number {{invoice.invoiceNumber}}, issued on {{formatDate invoice.invoiceDate}} and due on {{formatDate invoice.dueDate}}, despite our email reminders.</p>
        <p>Initial amount of the {{getInvoiceOrPaymentRequest lease}}: <strong>{{amountTotal}} €</strong><br>Amount already paid: <strong>{{amountPaid}} €</strong></p>
        <p>Remaining balance due: <strong>{{totalAmount}} €</strong></p>
        {{else}}
        <p>Unless we are mistaken, we have still not received payment of {{getInvoiceOrPaymentRequest lease}} number {{invoice.invoiceNumber}} of an amount of <strong>{{totalAmount}} €</strong> issued on {{formatDate invoice.invoiceDate}} and due on {{formatDate invoice.dueDate}}, despite our email reminders.</p>
        {{/if}}
        <p></p>
        <p>As a consequence, we are putting you on notice to pay the above-mentioned sum within 8 days from the date of this email, failing which we shall be obliged to initiate a conciliation procedure with the Justice of the Peace before any legal proceedings.</p>
        <p></p>
        <p>Payment information:</p>
        <ul><li>Account number held by {{getBankAccountHolder bankAccount}}: <strong>{{lease.bankAccount.number}}</strong></li>
        <li>Amount: <strong>{{totalAmount}} €</strong></li>
        {{#if (hasRemittanceInformation lease)}}
        <li>Remittance information: <strong>{{formatPaymentCommunication lease.remittanceInformation}}</strong></li>
        {{/if}}
        </ul>
        <p></p>
        <p>Please find a copy of the {{getInvoiceOrPaymentRequest lease}} attached.</p>
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-126002',
    language: Language.FR,
    subject: 'Mise en demeure pour montant impayé',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_UNPAID_AMOUNT_FORMAL_NOTICE,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerne: mise en demeure pour montant impayé relatif au bail sis <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        {{#if isPartiallyPaid}}
        <p>Sauf erreur de notre part, nous n'avons toujours pas reçu le paiement intégral de la {{getInvoiceOrPaymentRequest lease}} numéro {{invoice.invoiceNumber}}, émise le {{formatDate invoice.invoiceDate}} et due pour le {{formatDate invoice.dueDate}}, et ce malgré nos relances par email.</p>
        <p>Montant initial de la {{getInvoiceOrPaymentRequest lease}} : <strong>{{amountTotal}} €</strong><br>Montant déjà payé : <strong>{{amountPaid}} €</strong></p>
        <p>Solde restant dû : <strong>{{totalAmount}} €</strong></p>
        {{else}}
        <p>Sauf erreur de notre part, nous n'avons toujours pas reçu le paiement de la {{getInvoiceOrPaymentRequest lease}} numéro {{invoice.invoiceNumber}} d'un montant de <strong>{{totalAmount}} €</strong> émise le {{formatDate invoice.invoiceDate}} et due pour le {{formatDate invoice.dueDate}}, et ce malgré nos relances par email.</p>
        {{/if}}
        <p></p>
        <p>En conséquence, nous vous mettons en demeure de régler la somme susmentionnée endéans les 8 jours à compter de la présente, faute de quoi nous nous verrons dans l'obligation d'initier une procédure de conciliation auprès du Juge de Paix avant une éventuelle procédure judiciaire.</p>
        <p></p>
        <p>Informations de paiement:</p>
        <ul><li>Numéro de compte au nom de {{getBankAccountHolder bankAccount}}: <strong>{{lease.bankAccount.number}}</strong></li>
        <li>Montant: <strong>{{totalAmount}} €</strong></li>
        {{#if (hasRemittanceInformation lease)}}
        <li>Communication: <strong>{{formatPaymentCommunication lease.remittanceInformation}}</strong></li>
        {{/if}}
        </ul>
        <p></p>
        <p>Veuillez trouver une copie de la {{getInvoiceOrPaymentRequest lease}} en pièce jointe.</p>
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-126003',
    language: Language.NL,
    subject: 'Ingebrekestelling voor onbetaald bedrag',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_UNPAID_AMOUNT_FORMAL_NOTICE,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreffende: ingebrekestelling voor onbetaald bedrag met betrekking tot het huurcontract gelegen te <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        {{#if isPartiallyPaid}}
        <p>Tenzij wij ons vergissen, hebben wij nog steeds geen volledige betaling ontvangen van {{getInvoiceOrPaymentRequest lease}} nummer {{invoice.invoiceNumber}}, opgesteld op {{formatDate invoice.invoiceDate}} en verschuldigd op {{formatDate invoice.dueDate}}, ondanks onze aanmaningen per e-mail.</p>
        <p>Oorspronkelijk bedrag van de {{getInvoiceOrPaymentRequest lease}}: <strong>{{amountTotal}} €</strong><br>Reeds betaald bedrag: <strong>{{amountPaid}} €</strong></p>
        <p>Resterend verschuldigd saldo: <strong>{{totalAmount}} €</strong></p>
        {{else}}
        <p>Tenzij wij ons vergissen, hebben wij nog steeds geen betaling van ons {{getInvoiceOrPaymentRequest lease}} nummer {{invoice.invoiceNumber}} ten bedrage van <strong>{{totalAmount}} €</strong> opgesteld op {{formatDate invoice.invoiceDate}} en verschuldigd op {{formatDate invoice.dueDate}}, ondanks onze aanmaningen per e-mail.</p>
        {{/if}}
        <p></p>
        <p>Dientengevolge sommeren wij u bovengenoemd bedrag binnen 8 dagen na dagtekening van deze e-mail te betalen, bij gebreke daarvan zullen wij en bemiddelingsprocedure bij de Vrederechter in te leiden alvorens tot gerechtelijke vervolging over te gaan.</p>
        <p></p>
        <p>Betalings informatie:</p>
        <ul><li>Rekeningnummer bij {{getBankAccountHolder bankAccount}}: <strong>{{lease.bankAccount.number}}</strong></li>
        <li>Bedrag: <strong>{{totalAmount}} €</strong></li>
        {{#if (hasRemittanceInformation lease)}}
        <li>Mededeling: <strong>{{formatPaymentCommunication lease.remittanceInformation}}</strong></li>
        {{/if}}
        </ul>
        <p></p>
        <p>Gelieve een copie van ons {{getInvoiceOrPaymentRequest lease}} bijgevoegd te vinden.</p>
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
      `,
  },
  {
    id: '-126004',
    language: Language.DE,
    subject: 'Mahnung für unbezahlten Betrag',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_UNPAID_AMOUNT_FORMAL_NOTICE,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Sehr geehrte/r {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreff: Mahnung bezüglich eines unbezahlten Betrags im Zusammenhang mit dem Mietvertrag für die Immobilie in <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        {{#if isPartiallyPaid}}
        <p>Soweit wir nicht irren, haben wir trotz unserer E-Mail-Erinnerungen noch immer keine vollständige Zahlung der {{getInvoiceOrPaymentRequest lease}} Nummer {{invoice.invoiceNumber}} erhalten, die am {{formatDate invoice.invoiceDate}} ausgestellt wurde und am {{formatDate invoice.dueDate}} fällig war.</p>
        <p>Ursprünglicher Betrag der {{getInvoiceOrPaymentRequest lease}}: <strong>{{amountTotal}} €</strong><br>Bereits bezahlter Betrag: <strong>{{amountPaid}} €</strong></p>
        <p>Verbleibendes Restguthaben: <strong>{{totalAmount}} €</strong></p>
        {{else}}
        <p>Soweit wir nicht irren, haben wir trotz unserer E-Mail-Erinnerungen noch immer keine Zahlung der {{getInvoiceOrPaymentRequest lease}} Nummer {{invoice.invoiceNumber}} in Höhe von <strong>{{totalAmount}} €</strong> erhalten, die am {{formatDate invoice.invoiceDate}} ausgestellt wurde und am {{formatDate invoice.dueDate}} fällig war.</p>
        {{/if}}
        <p></p>
        <p>Infolgedessen mahnen wir Sie hiermit zur Zahlung des oben genannten Betrags innerhalb von 8 Tagen ab Datum dieser E-Mail, andernfalls sehen wir uns gezwungen, ein Schlichtungsverfahren beim Friedensrichter vor eventuellen gerichtlichen Verfahren einzuleiten.</p>
        <p></p>
        <p>Zahlungsinformationen:</p>
        <ul><li>Kontonummer bei {{getBankAccountHolder bankAccount}}: <strong>{{lease.bankAccount.number}}</strong></li>
        <li>Betrag: <strong>{{totalAmount}} €</strong></li>
        {{#if (hasRemittanceInformation lease)}}
        <li>Verwendungszweck: <strong>{{formatPaymentCommunication lease.remittanceInformation}}</strong></li>
        {{/if}}
        </ul>
        <p></p>
        <p>Im Anhang finden Sie eine Kopie der {{getInvoiceOrPaymentRequest lease}}.</p>
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
